import Notifier from 'common/helpers/Notifier';
import { isHttpSuccess } from 'src/api/utils/httpStatus';
import { coreApi } from 'src/api/config';

const createContactPreferences = async (personId, contactPreferences) => {
  try {
    const response = await coreApi.createRecord('contact_preference', {
      ...contactPreferences,
      person: personId,
    });

    if (!response || !isHttpSuccess(response.status)) {
      Notifier.handleErrors(response);
      return false;
    }

    return response;
  } catch (error) {
    Notifier.handleErrors(error);
    return false;
  }
};

export default createContactPreferences;
